var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumbleiconsUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9461_27598)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50018 5.41673V12.5417M7.50018 5.41673L9.87518 7.79173M7.50018 5.41673L5.12519 7.79173M11.8544 9.37506C13.0569 9.37506 13.8335 8.40052 13.8335 7.19798C13.8335 6.72188 13.6774 6.25893 13.3891 5.88002C13.1009 5.50111 12.6963 5.22713 12.2375 5.10006C12.1669 4.21217 11.7989 3.37404 11.1931 2.72118C10.5872 2.06831 9.77882 1.63886 8.89867 1.50227C8.01851 1.36568 7.11801 1.52993 6.34276 1.96846C5.56751 2.40699 4.96281 3.09416 4.62644 3.91889C3.91823 3.72258 3.16104 3.81564 2.52145 4.1776C1.88186 4.53956 1.41225 5.14077 1.21594 5.84898C1.01962 6.55718 1.11268 7.31437 1.47464 7.95396C1.8366 8.59355 2.43781 9.06316 3.14602 9.25948",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9461_27598"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumbleiconsUpload);
export default __webpack_public_path__ + "static/media/humbleicons_upload.7397c2c90561da9ef54e4a448e126315.svg";
export { ForwardRef as ReactComponent };